import React from 'react';
import { useLabels } from 'wsm-common-data';

const NoEventAlert = () => {
	const labels = useLabels();
	return (
		<div className="alert-info alert" role="alert">
			<i
				className="ddc-icon ddc-icon-alert align-left"
				data-testid="alert-icon"
			/>
			{` ${labels.get('SORRY_WE_CANT_FIND_YOUR_SUBARU_EVENT')} `}
		</div>
	);
};

export default NoEventAlert;
